export default () => ({
    play: false,
    played: false,
    videoplayer: null,
    playVideo() {
        this.play = !this.play;
        if (!this.played) {
            this.played = true;
        }
        if (this.$refs.video_poster) {
            this.$refs.video_poster.remove();
        }
    },
    init() {
        this.videoplayer = this.$el.getElementsByClassName('player')[0];
        this.$watch('play', (value) => {
            if (value) {
                this.videoplayer.play()
            } else {
                this.videoplayer.pause()
            }
        })
    }
})